import { useNavigate } from "react-router-dom";
import {
  BookOpen,
  ChefHat,
  CookingPot,
  Home,
  ShoppingBag,
  Tag,
  Utensils,
} from "lucide-react";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";
import FoodCategoryCard from "../cards/FoodCategoryCard";

const foodTypes = [
  {
    title: "Offer Foods",
    icon: Tag,
    path: "/all-food?foodType=offer",
  },
  {
    title: "Pre-Order",
    icon: ShoppingBag,
    path: "/all-food?foodType=pre-order",
  },
  {
    title: "Ready to Eat",
    icon: Utensils,
    path: "/all-food?foodType=ready-to-eat",
  },
  {
    title: "E-Shop",
    icon: CookingPot,
    path: "/all-food?foodType=e-shop",
  },
  {
    title: "Recipe",
    icon: BookOpen,
    path: "/all-recipes",
  },
  {
    title: "Kitchen",
    icon: Home,
    path: "/all-kitchens",
  },
  {
    title: "Chefs",
    icon: ChefHat,
    path: "/all-chefs",
  },
];

export default function FoodTypeSection() {
  const navigate = useNavigate();
  const totalCards = foodTypes.length;
  const breakpoints = {
    1200: { slidesPerView: Math.min(totalCards, 8), spaceBetween: 22 },
    992: { slidesPerView: 6, spaceBetween: 18 },
    768: { slidesPerView: 4.5, spaceBetween: 12 },
    576: { slidesPerView: 3.5, spaceBetween: 10 },
  };

  const handleNavigate = (path) => (e) => {
    e.preventDefault();
    navigate(path);
  };

  return (
    <div className="food-type-slider-container home-content-shell mt-md-2 pt-md-2">
      <div className="py-3 d-md-block d-lg-none"></div>
      <div className="py-5 d-none d-md-block"></div>
      <Swiper breakpoints={breakpoints} spaceBetween={20} slidesPerView={2.5}>
        {foodTypes?.map((type, index) => (
          <SwiperSlide key={index}>
            <button
              className="no-style-link w-100 d-block"
              onClick={handleNavigate(type.path)}
              aria-label={`Go to ${type.title}`}
              style={{ background: "transparent", border: 0, padding: 0 }}
            >
              <FoodCategoryCard
                label={type.title}
                icon={<type.icon size={24} color="#fff" />}
              />
            </button>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
